import { noveltyCheckContainer, ftoContainer, designFtoContainer, commonContainer } from './domains';

export { NoveltySearchContainer, FtoContainer, DesignFtoSearchContainer } from './domains';

export const checkingContainers = [commonContainer, noveltyCheckContainer, ftoContainer, designFtoContainer];
